import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import firebase from 'firebase'
import VueFire from 'vuefire'
import router from './router/index'

Vue.config.productionTip = false

var config = {
    apiKey: "AIzaSyDvAH9n1qFlQtAaTii-qsgTssiZFsfeXFU",
    authDomain: "fabrica-memes-6e168.firebaseapp.com",
    databaseURL: "https://fabrica-memes-6e168.firebaseio.com",
    projectId: "fabrica-memes-6e168",
    storageBucket: "fabrica-memes-6e168.appspot.com",
    messagingSenderId: "586791039100"
  };

const firebaseApp = firebase.initializeApp(config)
export const firestore = firebaseApp.firestore()
export const storage = firebase.storage().ref('/images')

Vue.use(VueFire)

new Vue({
  render: h => h(App),
  router,
  components: { App }
}).$mount('#app')
